import * as propertyTypes from "../property_types.js"


export class UiSearchFieldProps extends propertyTypes.AppBaseComponentProps {

    private autocompleteEnabledMetadata = new propertyTypes.CheckBoxProperty("autocompleteEnabled", "Autocomplete enabled");
    public autocompleteEnabled: boolean;

    private autocompleteTemplateMetadata = new propertyTypes.TextProperty("autocompleteTemplate", "Autocomplete template");
    public autocompleteTemplate: string;

    private autocompleteUrlMetadata = new propertyTypes.TextProperty("autocompleteUrl", "Autocomplete url");
    public autocompleteUrl: string;

    private autocompleteDataTextFieldMetadata = new propertyTypes.TextProperty("autocompleteDataTextField", "Autocomplete data textfield");
    public autocompleteDataTextField: string;

    private autocompleteAdditionalFilterParameterNameMetadata = new propertyTypes.TextProperty("autocompleteAdditionalFilterParameterName", "Autocomplete additional filter parameter name");
    public autocompleteAdditionalFilterParameterName: string;

    private autocompleteAdditionalFilterParameterMetadata = new propertyTypes.TextProperty("autocompleteAdditionalFilterParameter", "Autocomplete additional filter parameter");
    public autocompleteAdditionalFilterParameter: string;

    private searchButtonEnabledMetadata = new propertyTypes.CheckBoxProperty("searchButtonEnabled", "Search button enabled");
    public searchButtonEnabled: boolean;

    private searchWindowTitleMetadata = new propertyTypes.TextProperty("searchWindowTitle", "Search window title");
    public searchWindowTitle: string;

    private searchWindowUrlMetadata = new propertyTypes.TextProperty("searchWindowUrl", "Search window url");
    public searchWindowUrl: string;

    private searchWindowUrlParameterNameMetadata = new propertyTypes.TextProperty("searchWindowUrlParameterName", "Search window url parameter name");
    public searchWindowUrlParameterName: string;

    private searchWindowUrlParameterModelMetadata = new propertyTypes.TextProperty("searchWindowUrlParameterModel", "Search window url parameter model");
    public searchWindowUrlParameterModel: string;

    private searchWindowUrlAdditionalParameterNameMetadata = new propertyTypes.TextProperty("searchWindowUrlAdditionalParameterName", "Search window url additional parameter name");
    public searchWindowUrlAdditionalParameterName: string;

    private searchWindowUrlAdditionalParameterModelMetadata = new propertyTypes.TextProperty("searchWindowUrlAdditionalParameterModel", "SearchWindowUrlAdditionalParameterModel");
    public searchWindowUrlAdditionalParameterModel: string;

    private fullObjectKeyMetadata = new propertyTypes.TextProperty("fullObjectKey", "fullObjectKey");
    public fullObjectKey: string;

    private listWidthMetadata = new propertyTypes.TextProperty("listWidth", "listWidth");
    public listWidth: string;

    private readOnlyTextFieldMetadata = new propertyTypes.TextCheckboxProperty("readOnlyTextField", "readOnlyTextField");
    public readOnlyTextField: string;

    private customButtonEnabledMetadata = new propertyTypes.CheckBoxProperty("customButtonEnabled", "customButtonEnabled");
    public customButtonEnabled: boolean;

    private customButtonTitleMetadata = new propertyTypes.TextProperty("customButtonTitle", "customButtonTitle");
    public customButtonTitle: string;

    private customButtonFunctionMetadata = new propertyTypes.TextProperty("customButtonFunction", "customButtonFunction");
    public customButtonFunction: string;

    private deleteButtonEnabledMetadata = new propertyTypes.CheckBoxProperty("deleteButtonEnabled", "deleteButtonEnabled");
    public deleteButtonEnabled: boolean;

    private deleteButtonTitleMetadata = new propertyTypes.TextProperty("deleteButtonTitle", "deleteButtonTitle");
    public deleteButtonTitle: string;

    private newButtonEnabledMetadata = new propertyTypes.CheckBoxProperty("newButtonEnabled", "newButtonEnabled");
    public newButtonEnabled: boolean;

    private addNewUrlMetadata = new propertyTypes.TextProperty("addNewUrl", "addNewUrl");
    public addNewUrl: string;

    private newObjectKeyMetadata = new propertyTypes.TextProperty("newObjectKey", "newObjectKey");
    public newObjectKey: string;

    private newObjectWindowTitleMetadata = new propertyTypes.TextProperty("newObjectWindowTitle", "newObjectWindowTitle");
    public newObjectWindowTitle: string;

    private addNewUrlParametersMetadata = new propertyTypes.TextProperty("addNewUrlParameters", "addNewUrlParameters");
    public addNewUrlParameters: string;

    private canOpenAddMetadata = new propertyTypes.TextCheckboxProperty("canOpenAdd", "canOpenAdd");
    public canOpenAdd: string;

    private dataTextFieldMetadata = new propertyTypes.TextProperty("dataTextField", "dataTextField");
    public dataTextField: string;

    private dataValueFieldMetadata = new propertyTypes.TextProperty("dataValueField", "dataValueField");
    public dataValueField: string;

    private searchTextFieldMetadata = new propertyTypes.TextProperty("searchTextField", "searchTextField");
    public searchTextField: string;

    private searchValueFieldMetadata = new propertyTypes.TextProperty("searchValueField", "searchValueField");
    public searchValueField: string;

    private bulletMetadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata();
        this.bulletMetadataAll = baseMetaData.concat([this.autocompleteEnabledMetadata, this.autocompleteTemplateMetadata, this.autocompleteUrlMetadata,
        this.autocompleteDataTextFieldMetadata, this.autocompleteAdditionalFilterParameterNameMetadata, this.autocompleteAdditionalFilterParameterMetadata,
        this.searchButtonEnabledMetadata, this.searchWindowTitleMetadata, this.searchWindowUrlMetadata, this.searchWindowUrlParameterNameMetadata,
        this.searchWindowUrlParameterModelMetadata, this.searchWindowUrlAdditionalParameterNameMetadata, this.searchWindowUrlAdditionalParameterModelMetadata,
        this.fullObjectKeyMetadata, this.listWidthMetadata, this.readOnlyTextFieldMetadata, this.customButtonEnabledMetadata, this.customButtonTitleMetadata,
        this.customButtonFunctionMetadata, this.deleteButtonEnabledMetadata, this.deleteButtonTitleMetadata, this.newButtonEnabledMetadata, this.addNewUrlMetadata, this.newObjectKeyMetadata,
        this.newObjectWindowTitleMetadata, this.addNewUrlParametersMetadata, this.canOpenAddMetadata, this.dataTextFieldMetadata, this.dataValueFieldMetadata,
        this.searchTextFieldMetadata, this.searchValueFieldMetadata
        ]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.bulletMetadataAll;
    }
}
